// extracted by mini-css-extract-plugin
export default {"melodyVideo":"gP-z","isFullWidth":"hP-z","landingPageVideo":"iP-z","play":"jP-z","iframeVideo":"kP-z","playHidden":"lP-z","fullwidth":"mP-z"};